import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent {
  @Input() label: string;
  @Input() readonly: boolean;
  @Input() value: boolean;

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  onChange(event: any): void {
    this.value = event.target.checked;
    this.propagateChange(this.value);
  }

  registerOnTouched() {}

  private propagateChange = (_: any) => {};
}
